import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetCnaeResponse } from '../../responses/servico/get-cnae.response';
import { CreateCnaeResponse } from '../../responses/servico/create-cnae.response';
import { CnaeRequest } from '../../requests/servico/cnae.request';
import { CnaeBulkDeleteRequest } from '../../requests/servico/cnae-bulk-delete.request';
import { ReturnStruct } from '../../structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class CnaeService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'Cnae';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public getAll(
    pesquisa: string = '',
    pagina: number = 0,
    tamanhoPagina: number = 20
  ): Observable<GetCnaeResponse> {
    let params = new HttpParams()
      .set('pagina', pagina.toString())
      .set('tamanhoPagina', tamanhoPagina.toString());

    if (pesquisa) {
      params = params.set('pesquisa', pesquisa);
    }

    return this.httpClient
      .get<GetCnaeResponse>(this.apiUrl, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }

  public getById(id: number): Observable<CreateCnaeResponse> {
    const url = `${this.apiUrl}/idCnae/${id}`;
    return this.httpClient
      .get<CreateCnaeResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public create(request: CnaeRequest): Observable<CreateCnaeResponse> {
    return this.httpClient
      .post<CreateCnaeResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public update(id: number, request: CnaeRequest): Observable<CreateCnaeResponse> {
    const url = `${this.apiUrl}/idCnae/${id}`;
    return this.httpClient
      .put<CreateCnaeResponse>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteBulk(request: CnaeBulkDeleteRequest): Observable<ReturnStruct> {
    const url = `${this.apiUrl}/bulk-delete`;
    return this.httpClient
      .post<ReturnStruct>(url, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
